export default "__VITE_ASSET__BnvulOX9__"